module.exports = "https://qp-assets.quero.com/assets/images/login-bg-desktop.svg?d6949a82e1610774868b76ca97f93231";